exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-verify input[data-v-ab3bb4be]{width:66px;height:66px;border:none;outline:none;background-color:#f2f2f2;border-radius:2px;margin-right:12px;font-size:20px;text-align:center}.input-verify input[type=number][data-v-ab3bb4be]::-webkit-inner-spin-button,.input-verify input[type=number][data-v-ab3bb4be]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}@media screen and (min-width:320px) and (max-width:768px){.input-verify input[data-v-ab3bb4be]{width:50px;height:50px}}", ""]);

// exports
